/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import styled from "styled-components";
import grey from "@material-ui/core/colors/grey";
import { TableCell } from "@material-ui/core";
import stylesIdMap from "../../helpers/getStyles";

const StyledTableCellPinned = styled(({ styleIdMap, theme, ...props }) => (
  <TableCell {...props} />
))`
    border-bottom: none !important;

    &.upsRouteId {
      ${() => {
    const styles = stylesIdMap["code"];
    return `width: ${styles.width}px; 
              left: ${styles.left}px; 
              padding-left: ${styles.paddingLeft}px; 
              padding-right: ${styles.paddingRight}px;
              white-space: nowrap;`;
  }}
  }

    &.code {
        ${() => {
    const styles = stylesIdMap["code"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px;
                white-space: nowrap;`;
  }}
    }

    &.leg {
        ${() => {
    const styles = stylesIdMap["leg"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.trailer {
        ${() => {
    const styles = stylesIdMap["trailer"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.srv {
        ${() => {
    const styles = stylesIdMap["srv"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.miles {
        ${() => {
    const styles = stylesIdMap["miles"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.notes {
        ${() => {
    const styles = stylesIdMap["notes"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.alerts {
        ${() => {
    const styles = stylesIdMap["alerts"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.watched {
        ${() => {
    const styles = stylesIdMap["watched"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px`;
  }}
    }

    &.carrier {
        ${() => {
    const styles = stylesIdMap["carrier"];
    return `width: ${styles.width}px; 
                left: ${styles.left}px; 
                padding-left: ${styles.paddingLeft}px; 
                padding-right: ${styles.paddingRight}px;`;
  }}
        border-right: 2px solid ${grey[400]};
    }`;

export default StyledTableCellPinned;
